import axios from 'axios'
import { ChatRequest, ChatResponse, Forecast } from '../types'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000'

const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api/v1`,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const chatApi = {
  sendMessage: async (request: ChatRequest): Promise<ChatResponse> => {
    const response = await apiClient.post<ChatResponse>('/chat', request)
    return response.data
  },
}

export const forecastApi = {
  getForecast: async (
    latitude: number,
    longitude: number,
    locationName: string,
    timezone: string = 'UTC'
  ): Promise<Forecast> => {
    const response = await apiClient.get<Forecast>('/forecast', {
      params: {
        latitude,
        longitude,
        location_name: locationName,
        timezone,
      },
    })
    return response.data
  },
}

export const healthApi = {
  checkHealth: async (): Promise<{ status: string; timestamp: string }> => {
    const response = await apiClient.get('/health')
    return response.data
  },
}

export default apiClient
